import { useState } from "react";
import { toast } from "sonner";
import { FileText, Download, X } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { PdfDialog } from "./PdfDialog";

// Ticked leads are only for a PDF: view it on screen or download it.
export const PdfBar = ({ ids, onClear }) => {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const make = async (download) => {
    setBusy(true);
    try {
      const { data } = await api.post("/leads/pdf", { lead_ids: ids }, { responseType: "blob" });
      const u = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
      if (!download) return setUrl(u);
      const a = document.createElement("a");
      a.href = u; a.download = "POS-Finder-Leads.pdf"; a.click();
      setTimeout(() => URL.revokeObjectURL(u), 2000);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  const btn = "h-10 px-4 rounded-full text-sm font-semibold flex items-center gap-1.5 transition-colors disabled:opacity-50";
  return (
    <>
      <div className="fixed bottom-6 inset-x-0 z-40 flex justify-center px-3 pointer-events-none">
        <div className="pointer-events-auto flex flex-wrap justify-center items-center gap-1.5 bg-slate-900 text-white rounded-3xl pl-5 pr-2 py-2 shadow-2xl fade-up max-w-full" data-testid="pdf-bar">
          <span className="text-sm mr-1.5" data-testid="selected-count">{ids.length} selected</span>
          <button onClick={() => make(false)} disabled={busy} className={`${btn} bg-white text-slate-900 hover:bg-slate-100`} data-testid="pdf-view"><FileText className="h-4 w-4" />{busy ? "Making PDF…" : "View PDF"}</button>
          <button onClick={() => make(true)} disabled={busy} className={`${btn} bg-blue-600 hover:bg-blue-500 text-white`} data-testid="pdf-download"><Download className="h-4 w-4" />Download PDF</button>
          <button onClick={onClear} aria-label="Clear selection" className="h-10 w-10 rounded-full hover:bg-slate-800 flex items-center justify-center transition-colors" data-testid="pdf-clear"><X className="h-4 w-4" /></button>
        </div>
      </div>
      <PdfDialog url={url} title={`${ids.length} lead${ids.length === 1 ? "" : "s"}`} filename="POS-Finder-Leads.pdf" onClose={() => { URL.revokeObjectURL(url); setUrl(null); }} testid="leads-pdf-viewer" />
    </>
  );
};
